var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-flex',{attrs:{"lg12":""}},[(_vm.user)?_c('CriarMensagem',{attrs:{"tammaximo":"700"},on:{"postar":_vm.postar}}):_vm._e()],1),_c('v-flex',{attrs:{"lg12":""}},[_c('Mensagem',{attrs:{"mensagens":_vm.mensagens}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }